<template>
  <BaseLoading  opaque :spinning="clubTeamHighlightLoading">
    <CollegeForm :resource="clubTeamHighlight" working-type="edit"/>
  </BaseLoading>
</template>

<script>
import { ClubTeamHighlight } from "@/models"
import { mapGetters } from "vuex"
import CollegeForm from "./form"

const CLUB_TEAM_HIGHLIGHT_STORE = "clubTeamHighlightStore"

export default {
  components: {
    CollegeForm,
  },
  created() {
    this.dispatcher()
  },
  data() {
    return {
      resource: new ClubTeamHighlight(),
    }
  },
  computed: {
    ...mapGetters({
      clubTeamHighlight: `${CLUB_TEAM_HIGHLIGHT_STORE}/clubTeamHighlight`,
      clubTeamHighlightLoading: `${CLUB_TEAM_HIGHLIGHT_STORE}/clubTeamHighlightLoading`,
    })
  },
  methods: {
    async dispatcher() {
      await this.$store.dispatch(`${CLUB_TEAM_HIGHLIGHT_STORE}/getClubTeamHighlight`, {
        id: this.$route.params['id']
      })
    },
  }
}
</script>

<style lang="sass" scoped>
</style>
